export default __webpack_public_path__ + "static/media/b-sm2.3a5300a1.png";